/* eslint-disable no-console */

import {
  ColDef,
  ColumnApi,
  Events,
  FirstDataRenderedEvent,
  GetContextMenuItemsParams,
  GridApi,
  GridOptions,
  GridReadyEvent,
  IServerSideDatasource,
  IServerSideGetRowsParams,
  ISetFilterParams,
  MenuItemDef,
  ModelUpdatedEvent,
  Module,
  RowClassParams,
  RowNode,
  SelectionChangedEvent,
} from '@ag-grid-community/core'
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel'
import { MasterDetailModule } from '@ag-grid-enterprise/master-detail'
import { MenuModule } from '@ag-grid-enterprise/menu'
import { RangeSelectionModule } from '@ag-grid-enterprise/range-selection'
import { ServerSideRowModelModule } from '@ag-grid-enterprise/server-side-row-model'
import { DOCUMENT } from '@angular/common'
import { HttpErrorResponse } from '@angular/common/http'
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
} from '@angular/core'
import { FormControl, Validators } from '@angular/forms'
import {
  disableChangeDetectionOnScroll,
  enableHeliosCopyBehavior,
  enableHeliosGridDensityLevel,
  enableHeliosMultiRowDragSelection,
  generateHeliosAgGridSidebarFromScratch,
  generateMdiIcon,
  getFilterOnCellContextMenu,
  HeliosColumnTypes,
  heliosColumnTypes,
  heliosDefaultColWidth,
  heliosDefaultToolPanels,
  heliosMultiRowSelectionConfig,
  heliosServerSideRowConfig,
  NumberFilterOptionsWithAbsolute,
  NumberFilterOptionsWithoutEquals,
  setFilter,
  TextFilterOptionsWithContainsIn,
} from '@helios/ag-grid-config'
import { Command, CommandService, RunType } from '@helios/commands'
import { formatDates, formatDateTime } from '@helios/common-api'
import {
  AdvancedOptionsParams,
  FilterModalEvent,
  FilterModalService,
  FilterModel,
  RevertFilterService,
} from '@helios/filter-modal'
import {
  Account,
  AccountAvailableActions,
  AccountsRequestContext,
  AccountsSetValues,
  accountTypes,
  accountTypesFilterCellRenderer,
  AdvancedFilters,
  ContextualLabelingColors,
  getAccountRowCountRequest,
  getBooleanTypeCellRenderer,
  HighlightingService,
  isAccountSleeveType,
  mergeBaseColDefsWithColumnState,
  ReconRunStatus,
  reconRunStatusTypesCellRenderer,
  reconRunStatusTypesCellRendererWithText,
} from '@helios/generic-components'
import {
  HighlightRowsInAccountList,
  HotkeyDestroyFn,
  HotkeysService,
} from '@helios/hotkeys'
import { BulkActivateNewerExternalDataComponent } from '@helios/panels/external-file-manager'
import {
  convertFilters,
  convertToTimeFilters,
  countFilters,
  handleColumnVisibilityChange,
  toHeliosRequest,
} from '@helios/server-side-util'
import {
  CommentaryCountsService,
  CommentaryLiveAccountsService,
  CommentaryEntityRef,
  CommentaryEntitySearchService,
  CommentaryFollowService,
  CommentaryGridSelectionService,
  CommentCountCellRenderer,
  commentCountRendererKey,
  wireCommentaryGrid,
  wireCommentaryCounts,
  refilterOnThreadChanges,
  getCommentaryColumnIfAccessible,
  getCommentaryContextMenuItems,
  COMMENTARY_COLUMN_ID,
  accountCounts,
} from '@helios/comments'
import { CANNOT_LOAD_AGG_ACCOUNT } from '@helios/sessions'
import {
  PeriodLength,
  periodLengthToDate,
  RootState,
  selectActiveSavedViewForGrid,
  selectSavedViewExistsForGridKey,
  selectUserPolicy,
  SessionWithState,
  setSelectedReconDate,
  User,
  userHasCommentaryAccess,
  UserPolicy,
} from '@helios/state-management'
import {
  createFilterGroupsToolPanel,
  DensityLevel,
  FilterGroupsToolPanelParams,
  KeyValueUiStorageService,
  ModalPositionService,
  UserPreferencesService,
  WorkspaceGridSavedViewService,
  WorkspaceUpdateEventObject,
} from '@helios/user-preferences'
import {
  checkIfDateIsWithinRange,
  downloadExcelFile,
  getYesterday,
} from '@helios/utils'
import { IntegerIdListValidator } from '@helios/validators'
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap'
import { Store } from '@ngrx/store'
import { AgGridApi, NfColumnTypes, NfTooltipParams } from '@northfork/ag-grid'
import { AgGridState } from '@northfork/ag-grid-angular'
import {
  composeFieldPath,
  DisplayDateFormat,
  formatDate,
  ISODateFormat,
} from '@northfork/basics'
import { ToastService } from '@northfork/ng-basics'
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { refreshSetValuesForAllSetFilterColumns } from 'libs/filter-modal/src/lib/utils/column-filter-utils'
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { GenericConfirmationModalService } from 'libs/generic-components/src/lib/generic-confirmation-modal/generic-confirmation-modal.service'
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { createPanelSettingsToolPanel } from 'libs/generic-components/src/lib/panel-settings-tool-panel/utils/panel-settings-tool-panel-sidebar-utils'
import { isEmpty, throttle } from 'lodash-es'
import { Observable, of, Subject } from 'rxjs'
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  shareReplay,
  take,
  takeUntil,
  tap,
} from 'rxjs/operators'
import { AccountListKey } from '../../panel-key'
import {
  AccountListStatusBarModule,
  accountListStatusBarPanel,
} from '../account-list-status-bar/account-list-status-bar.module'
import { ConfigureBellModalService } from '../account-list-status-bar/omega-timestamp-status-bar/configure-bell-modal/configure-bell-modal.service'
import { AdvancedFiltersComponent } from '../advanced-filters/advanced-filters.component'
import {
  AccountListService,
  AdvancedFilterContext,
  ExportExcelRequest,
  ReconDateBasedFilters,
} from '../services/account-list.service'
import { sumBreaksForAccount } from '../utils/break-counter'
import { accountCommentary } from './account-list-commentary'
import { AccountListFilterActionsComponent } from './account-list-filter-actions/account-list-filter-actions'
import {
  AccountListAggregatesDropdown,
  priorityCellRenderer,
} from './account-list-grid-helpers/account-list-grid-helpers'
import { complianceViolationCellRenderer } from './account-list-grid-helpers/complianceViolationCellRenderer'
import { issueTypeCellRenderer } from './account-list-grid-helpers/issueTypeCellRenderer'
import { issueTypeTooltipValueGetter } from './account-list-grid-helpers/issueTypeTooltipValueGetter'
import { usersInAccountCellRenderer } from './account-list-grid-helpers/usersInAccountCellRenderer'

/**
 * DO NOT CHANGE. Saved Views and Filter Groups depend on this key. Changing will result in users losing their saved
 * preferences for this grid.
 */
export const AccountListMainGridKey = `${AccountListKey}-MainGrid`
const AccountListMainGridRowClass = `${AccountListMainGridKey}-row`

export const IssuesType = 'IssuesType'

const accountPath = composeFieldPath([] as Account[])

@Component({
  selector: 'hs-account-list-grid',
  templateUrl: './account-list-grid.component.html',
  styleUrls: ['./account-list-grid.component.scss'],
  providers: [FilterModalService, HighlightingService, RevertFilterService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountListGridComponent implements OnInit, OnDestroy {
  private readonly destroySubject$ = new Subject<void>()
  @ViewChild(AccountListFilterActionsComponent, { static: false })
  filterActionsComponent?: AccountListFilterActionsComponent
  dateFormat = DisplayDateFormat
  filterCount = 0
  _actualReconDate?: string
  _approvalAccountIds?: number[]
  _isRendered = false
  isReconDateOutside = false // when recon date is outside of current date, means not today or yesterday
  isReconDateWithinLast7Days = false // to check when recon date is within 7 days or not
  private _session?: SessionWithState | null

  clearFiltersOnAccountLoadToggle = new FormControl(true)
  @Input() set session(session: SessionWithState | null | undefined) {
    const oldSession = this._session
    this._session = session
    if (this.api == null) {
      return
    }

    const rowNodes: RowNode[] | undefined = []
    const api = this.api
    if (!this._isRendered) {
      return
    }
    ;[oldSession, session]
      .filter(s => s?.loadedAccountIds.length ?? -1 > 0)
      .forEach(s => {
        const sessionRow =
          s?.loadedAccountIds
            .map(accountId => api.getRowNode(accountId.toString()))
            .filter((node): node is RowNode => node != null) ?? []

        rowNodes.push(...sessionRow)
      })

    // Throwing redrawRows on its own thread to prevent UI blocking.
    setTimeout(() => {
      api?.redrawRows({ rowNodes })
    }, 1)
  }
  @Input() currentUser?: User | null

  /**
   * This gets called on every account add, delete & update event. Due to this state being globally shared I expect
   * this to get called A LOT. I did not want to leave this as the only inline update table. If we do run into
   * performance issues on the backend we will need to come up with some new solutions that allow us to refresh the grid
   * in a more performant manner, which may take both backend and front end work.
   *
   * @param accountIds
   */
  @Input()
  set rowUpdated(accountIds: number[] | null) {
    if (accountIds == null) return
    if (accountIds.length === 0) return
    if (this.api == null) return
    const api = this.api

    if (
      accountIds.some(accountId => api.getRowNode(accountId.toString()) != null)
    )
      this.refreshServerSideStoreShort()
    else this.refreshServerSideStoreLong()
  }

  @Input()
  set actualReconDate(dateString: string | null) {
    if (dateString == null) {
      return
    }
    this.reconDateControl.setValue(dateString)
    this.advancedFilterContext.reconDate = dateString
    this._actualReconDate = dateString
  }

  @Input()
  set approvalsAccountList(accountList: number[] | undefined) {
    if (!accountList || accountList.length === 0) {
      return
    }
    this.setApprovalFilter(accountList)
  }

  setApprovalFilter(accountList: number[]) {
    this.clearFilters()
    setFilter<Account>(
      'accountId',
      {
        type: 'in',
        filterType: 'number',
        filter: accountList.toString(),
      },
      this.api,
    )
  }

  /**
   * @internal
   */
  readonly refreshServerSideStoreShort = throttle(
    () => {
      if (!this._isRendered) return
      this.resetAccountsSetValues()
      this.api?.refreshServerSideStore({ purge: false })
    },
    2000, //2 seconds
    { leading: false, trailing: true },
  )

  /**
   * @internal
   */
  readonly refreshServerSideStoreLong = throttle(
    () => {
      this.refreshServerSideStoreShort()
    },
    60000, //1 minute
    { leading: false, trailing: true },
  )

  @Output() activateExternalData = new EventEmitter<string>()
  @Output() onAccountsSelected = new EventEmitter<number[]>()
  /**
   * DLITE-4110: the commentary-eligible account for the current selection, or
   * null when the selection can't drive the comments drawer (nothing selected,
   * multiple rows, or an aggregate account).
   */
  @Output() onCommentaryAccountSelected = new EventEmitter<number | null>()
  @Output() onTotalBreaksSelected = new EventEmitter<number>()
  @Output() onAccountsInViewChange = new EventEmitter<number[]>()
  @Output() onLoadAccount = new EventEmitter<{
    accountIds: number[]
    reconDate: Date
    withModal: boolean
    isLIBAccount: boolean
  }>()

  @Output() loadAccountWithTimePeriod = new EventEmitter<{
    accountIds: number[]
    reconDate: Date
    periodLength: PeriodLength
    isLIBAccount: boolean
  }>()

  /**
   * @internal
   */
  readonly aggregateChanged = new EventEmitter<number>()

  /** @internal */
  readonly gridOptions$ = this.createGridOptions()

  readonly gridModules: Module[] = [
    MasterDetailModule,
    FiltersToolPanelModule,
    ServerSideRowModelModule,
    MenuModule,
    RangeSelectionModule,
    AccountListStatusBarModule,
  ]

  accountsSetValues$: Observable<AccountsSetValues> =
    this.getAccountsSetValues()
  advancedFilterContext: AdvancedFilterContext = {
    advancedFilters: {},
    reconDate: formatDate(getYesterday(), ISODateFormat) ?? '', // since getYesterday always returns date value so recon date won't be blank
  }
  filtersCleared = new EventEmitter<void>()
  reconDateControl = new FormControl(
    formatDate(getYesterday(), ISODateFormat),
    [Validators.required],
  )
  quickSearch = new FormControl([''])
  quickSearchAccountIds = new FormControl('', IntegerIdListValidator)
  clearFiltersEnabled = false
  selectedRows?: AgGridApi
  private readonly hotkeyDestroyStack: HotkeyDestroyFn[] = []
  private readonly filterChanged = () => {
    this.clearFiltersEnabled = this.api?.isAnyFilterPresent() ?? false
  }

  /** @internal */
  api?: GridApi
  columnApi?: ColumnApi

  isExternalFilterPresent = false
  accessRunAI = false

  /**
   * @internal
   */
  get filterGroupsToolPanelParams(): FilterGroupsToolPanelParams<AdvancedFilters> {
    return {
      gridKey: AccountListMainGridKey,
      getExternalFilters: () => this.advancedFilterContext.advancedFilters,
      setExternalFilters: (advancedFilters: AdvancedFilters) =>
        this.advancedFiltersChanged(advancedFilters),
      cacheLoaded: of(true), //Cache state is irrelevant to this panel,
    }
  }

  hasAccessCommentary = false

  constructor(
    private readonly accountListService: AccountListService,
    private readonly commandService: CommandService,
    private readonly resolver: ComponentFactoryResolver,
    private readonly container: ViewContainerRef,
    private readonly savedViewService: WorkspaceGridSavedViewService,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly modalService: NgbModal,
    readonly modalPositionService: ModalPositionService,
    private readonly store: Store<RootState>,
    // @internal
    public filterModalService: FilterModalService,
    private readonly preferences: UserPreferencesService,
    private readonly highlightService: HighlightingService,
    private readonly keyValueUiStorageService: KeyValueUiStorageService,
    private readonly hotkeysService: HotkeysService<HighlightRowsInAccountList>,
    @Inject(DOCUMENT) private readonly document: Document,
    public revertFilterService: RevertFilterService,
    private readonly toastService: ToastService,
    private readonly configureBellModalService: ConfigureBellModalService,
    private readonly genericConfirmationModalService: GenericConfirmationModalService,
    private readonly commentaryCountsService: CommentaryCountsService,
    private readonly commentaryLiveAccounts: CommentaryLiveAccountsService,
    private readonly commentaryFollowService: CommentaryFollowService,
    private readonly entitySearchService: CommentaryEntitySearchService,
    private readonly gridSelectionService: CommentaryGridSelectionService,
  ) {
    this.filtersCleared
      .pipe(
        takeUntil(this.destroySubject$),
        tap(() => this.advancedFiltersChanged({})),
      )
      .subscribe()

    this.aggregateChanged
      .pipe(takeUntil(this.destroySubject$))
      .subscribe(id => {
        this.clearFilters()
        const advancedFilters = {
          ...this.advancedFilterContext.advancedFilters,
        }
        advancedFilters.aggregateId = [id]
        this.advancedFiltersChanged(advancedFilters)
      })

    this.store
      .select(selectUserPolicy)
      .pipe(
        filter(policy => policy != undefined),
        take(1),
      )
      .subscribe(userPolicy => {
        this.checkAIAccess(userPolicy)
      })
  }
  checkAIAccess(userPolicy?: UserPolicy) {
    if (userPolicy) {
      this.accessRunAI =
        userPolicy.accessDeveloperTools || userPolicy.accessBetaFeatures
      this.hasAccessCommentary = userHasCommentaryAccess(userPolicy)
      if (this.hasAccessCommentary) {
        this.wireCommentary()
      }
    }
  }

  /**
   * DLITE-3849 — wire this grid into the commentary drawer (follow-a-chip row
   * focus + entitySearch/pickEntities sources). account-list owns `account`;
   * the row-node id is `accountId.toString()`, so focusGridRow looks the node
   * up directly and falls back to an `accountId` filter only if it isn't
   * loaded. Idempotent; torn down via destroySubject$.
   */
  private wireCommentary() {
    if (this.commentaryWired) return
    this.commentaryWired = true
    wireCommentaryGrid({
      follow: this.commentaryFollowService,
      search: this.entitySearchService,
      selection: this.gridSelectionService,
      panelKey: AccountListKey,
      entityType: 'account',
      idColId: 'accountId',
      getApi: () => this.api,
      hasAccess: () => this.hasAccessCommentary,
      destroy$: this.destroySubject$,
      loadedRefs: () => this.collectLoadedAccountRefs(),
      selectedRefs: () => this.collectSelectedAccountRefs(),
      // `accountId` is a numeric column (NumberFilterOptionsWithoutEquals), so
      // a text/equals reveal filter matches nothing. Mirror setApprovalFilter's
      // number/in filter so following a chip for an unloaded account actually
      // fetches and reveals the row instead of emptying the grid.
      idFilter: id => ({ filterType: 'number', type: 'in', filter: id }),
    })
  }
  private commentaryWired = false

  private collectLoadedAccountRefs(): CommentaryEntityRef[] {
    const refs: CommentaryEntityRef[] = []
    this.api?.forEachNode(node => {
      const id = (node.data as Account)?.accountId
      if (id != null) refs.push({ type: 'account', id: id.toString() })
    })
    return refs
  }

  private collectSelectedAccountRefs(): CommentaryEntityRef[] {
    return (this.api?.getSelectedNodes() ?? [])
      .map(node => (node.data as Account)?.accountId)
      .filter((id): id is number => id != null)
      .map(id => ({ type: 'account' as const, id: id.toString() }))
  }

  ngOnInit() {
    this.filterModalService.setValidators({
      accountId: IntegerIdListValidator,
    })
    this.quickSearch.valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        takeUntil(this.destroySubject$),
      )
      .subscribe(() => this.updateQuickFilter())

    this.quickSearchAccountIds.valueChanges
      .pipe(
        debounceTime(400),
        distinctUntilChanged(),
        takeUntil(this.destroySubject$),
      )
      .subscribe(() => this.updateQuickSearchAccountIds())

    this.reconDateControl.valueChanges
      .pipe(takeUntil(this.destroySubject$))
      .subscribe((reconDateString: string) => {
        this.advancedFilterContext.reconDate = reconDateString
        this.updateReconDateFilter(reconDateString)
      })

    this.clearFiltersOnAccountLoadToggle.valueChanges.subscribe(() => {
      this.updateGridConfig()
    })

    this.registerHotkeys()
  }

  ngAfterViewInit() {
    if (this.filterActionsComponent) {
      this.filterActionsComponent.gridApi = this.api
    }
  }

  ngOnDestroy() {
    this.api?.removeEventListener(
      Events.EVENT_FILTER_CHANGED,
      this.filterChanged,
    )
    this.unregisterHotkeys()
    this.revertFilterService.destroy()

    this.destroySubject$.next()
    this.destroySubject$.complete()
    this.api?.destroy()
    this.filterModalService.destroy()
  }

  updateGridConfig() {
    const panelSettingsChangedEvent = new CustomEvent('panelSettingsChanged', {
      detail: {
        api: { api: this.api, columnApi: this.columnApi },
        panelSettings: this.getCurrentPanelSettingsObject(),
      } as WorkspaceUpdateEventObject,
    })
    this.api?.dispatchEvent(panelSettingsChangedEvent)
  }

  getCurrentPanelSettingsObject() {
    const panelSettings: { [key: string]: unknown } = {}
    panelSettings['clearFiltersOnAccountLoad'] =
      this.clearFiltersOnAccountLoadToggle.value
    return panelSettings
  }

  private applyGridConfig(agGridStateSaved: AgGridState) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const panelSettings = agGridStateSaved.panelSettings as any

    if (panelSettings) {
      if ('clearFiltersOnAccountLoad' in panelSettings) {
        this.clearFiltersOnAccountLoadToggle.patchValue(
          Boolean(panelSettings.clearFiltersOnAccountLoad),
          { emitEvent: false },
        )
      }
    }
  }

  onRowSelectionChanged(event: SelectionChangedEvent) {
    this.selectedRows = event as AgGridApi
    const accountIds: number[] = this.getSelectedAccountIds(event.api)
    const totalAccountBreaksSelected: number = this.getSelectedBreaksSum(
      event.api,
    )

    this.onAccountsSelected.next(accountIds)
    this.onTotalBreaksSelected.next(totalAccountBreaksSelected)
    this.onCommentaryAccountSelected.next(
      this.getCommentaryAccountId(event.api),
    )

    this.updateRelatedSleeveAccountHighlighting(event.api)
  }

  /**
   * DLITE-4110: resolve the account whose comments the drawer should show for
   * the current selection. Only a single, non-aggregate row qualifies —
   * aggregates can't be loaded and commentary is simple-scoped, and a
   * multi-row selection is ambiguous for a single-account drawer. Returns null
   * in those cases so the caller leaves the drawer's account unchanged.
   */
  private getCommentaryAccountId(api: GridApi): number | null {
    const selectedNodes = api.getSelectedNodes()
    if (selectedNodes.length !== 1) return null
    const account = selectedNodes[0].data as Account
    return account.accountType === 'aggregate' ? null : account.accountId
  }

  updateRelatedSleeveAccountHighlighting(gridApi: GridApi) {
    this.document
      .querySelectorAll(`.group-highlight.${AccountListMainGridRowClass}`)
      .forEach(e => e.classList.remove('group-highlight'))

    this.getSelectedSleeveAccountIdsToHighlight(gridApi).forEach(id => {
      const nodeIds = this.document.querySelectorAll(
        `.${AccountListMainGridKey}-${id}`,
      )
      nodeIds.forEach(element => element.classList.add('group-highlight'))
    })
  }

  /**
   * Gets all the sleeve account ids that need to be highlighted. These accounts have a related sleeve account
   * in the current selection and there is at least two accounts belonging to each cluster.
   *
   * @param gridApi
   */
  getSelectedSleeveAccountIdsToHighlight(gridApi: GridApi) {
    const selectedParentIds = this.getSelectedParentPortfolioIds(gridApi)
    if (selectedParentIds.length === 0) return [] //If this is empty, then there are no selected sleeve accounts and there is nothing to highlight

    const parentToSleeveCluster =
      this.getAllSleeveClustersForGivenParentPortfolioIds(
        gridApi,
        selectedParentIds,
      )

    //We only want to highlight sleeve accounts if at least two in a set are selected
    const accountIdsToHighlight: number[] = []
    for (const accounts of parentToSleeveCluster.values()) {
      if (accounts.size > 1) accountIdsToHighlight.push(...accounts)
    }

    return accountIdsToHighlight
  }

  /**
   * @internal
   * @param gridApi
   */
  getSelectedParentPortfolioIds(gridApi: GridApi): number[] {
    const selectedParentPortfolioIds = gridApi
      .getSelectedNodes()
      .map(x => x.data as Account)
      .filter(account => isAccountSleeveType(account))
      .map(account =>
        account.accountType === 'sleeveAggregate'
          ? account.accountId
          : account.sleeveAggregateId,
      )
      .filter((accountId): accountId is number => accountId != null)
    return [...new Set(selectedParentPortfolioIds)]
  }

  /**
   * Gets all the sleeve clusters that are in the grids loaded data set.
   * A sleeve cluster is the parent porfolio + all the sub-sleeves
   *
   * @param gridApi
   * @param parentPortfolioIds
   */
  getAllSleeveClustersForGivenParentPortfolioIds(
    gridApi: GridApi,
    parentPortfolioIds: number[],
  ): Map<number, Set<number>> {
    const parentToSleeveCluster = new Map<number, Set<number>>()
    parentPortfolioIds.forEach(parentId =>
      parentToSleeveCluster.set(parentId, new Set<number>()),
    )

    gridApi.forEachNode(node => {
      const account = node.data as Account
      if (!isAccountSleeveType(account)) {
        return
      }

      const accountId = account.accountId
      const parentAccountId =
        account.accountType === 'sleeveAggregate'
          ? accountId
          : account.sleeveAggregateId
      if (parentAccountId == null) {
        return
      }

      const cluster = parentToSleeveCluster.get(parentAccountId)
      if (cluster == null) return

      cluster.add(accountId)
    })

    return parentToSleeveCluster
  }

  getSelectedBreaksSum(api: GridApi) {
    const selectedNodes = api.getSelectedNodes()
    return selectedNodes.reduce((sum, node) => {
      const data = node.data as Account
      return sum + sumBreaksForAccount(data)
    }, 0)
  }

  getSelectedAccountIds(api?: GridApi): number[] {
    if (api == null) return []

    return api.getSelectedNodes().map(x => (x.data as Account).accountId)
  }

  onRowDoubleClicked(account: Account) {
    const isImplementationNullOrFuture =
      !account.implementationCompleteDate ||
      new Date(account.implementationCompleteDate) > new Date()
    const isStartDateWithinLastTwoYears =
      account.startDate &&
      new Date(account.startDate) >= periodLengthToDate(PeriodLength.Last2Years)
    //load for all time if implementation is not complete and start date is within last two years
    if (isImplementationNullOrFuture && isStartDateWithinLastTwoYears) {
      this.autoLoadAccount(
        account.accountId,
        PeriodLength.Last2Years,
        account.isLIB,
      )
    } else {
      this.loadAccount(account.accountId, false, account.isLIB)
    }
  }

  /*@internal*/
  loadAccount(accountId: number, withModal: boolean, isLIBAccount: boolean) {
    this.onLoadAccount.emit({
      accountIds: [accountId],
      reconDate:
        (this.advancedFilterContext.reconDate as unknown as Date) ?? new Date(),
      withModal,
      isLIBAccount,
    })
  }

  autoLoadAccount(
    accountId: number,
    length: PeriodLength,
    isLIBAccount: boolean,
  ) {
    console.log('autoLoadAccount:', accountId, length, isLIBAccount)
    const reconDate = this.advancedFilterContext.reconDate
    if (reconDate instanceof Date) {
      console.log('reconDate:', reconDate)
    } else {
      console.log('reconDate is not an instance of Date:', reconDate)
    }
    console.log(
      'advancedFilterContext.reconDate:',
      this.advancedFilterContext.reconDate,
    )
    this.loadAccountWithTimePeriod.emit({
      accountIds: [accountId],
      reconDate:
        (this.advancedFilterContext.reconDate as unknown as Date) ?? new Date(),
      periodLength: length,
      isLIBAccount,
    })
  }

  /**
   * The right click magic
   *
   * @internal
   */
  getContextMenuItems(params: GetContextMenuItemsParams) {
    const data = params?.node?.data ?? {}
    const accountId = data.accountId
    const accountType = data.accountType || ''
    const isAggregate = accountType === 'aggregate'
    const isLIB = data.isLIB
    const selectedRows = params.api?.getSelectedNodes()
    if (selectedRows.length == 0) {
      if (params?.node) selectedRows.push(params.node)
    } //If we directly click Right button before selecting row getSelectedNodes return null.
    const disableAccountRun = this.shouldDisableAction(selectedRows, 'run')
    const disableAccountRunWithoutEtl = this.shouldDisableAction(
      selectedRows,
      'runWithoutEtls',
    )

    let accountIdsToTakeActionsAgainst = this.getSelectedAccountIds(
      params.api ?? undefined,
    )
    if (
      accountIdsToTakeActionsAgainst.length === 0 ||
      !accountIdsToTakeActionsAgainst.includes(accountId)
    )
      accountIdsToTakeActionsAgainst = [accountId]

    const numCommands: number = (this._session?.accountCommands ?? [])
      .filter(ac => accountIdsToTakeActionsAgainst.includes(ac.accountId))
      .reduce((sum, ac) => sum + ac.commandCount, 0)

    let runAccountsString = `Run account(s)`
    if (numCommands > 0) {
      runAccountsString = `Submit (${numCommands}) commands`
    }

    const aitools: Array<string | MenuItemDef> = []

    const result: (string | MenuItemDef)[] = [
      {
        name: `Load Account ${accountId}`,
        disabled: isAggregate,
        tooltip: isAggregate ? CANNOT_LOAD_AGG_ACCOUNT : undefined,

        subMenu: [
          {
            name: 'Last 30 days',
            action: () =>
              this.autoLoadAccount(accountId, PeriodLength.Last30Days, isLIB),
          },
          {
            name: 'Last 100 days',
            action: () =>
              this.autoLoadAccount(accountId, PeriodLength.Last100Days, isLIB),
          },
          {
            name: 'Last 1 year',
            action: () =>
              this.autoLoadAccount(accountId, PeriodLength.Last1Year, isLIB),
          },
          {
            name: 'Last 2 years',
            action: () =>
              this.autoLoadAccount(accountId, PeriodLength.Last2Years, isLIB),
          },
          {
            name: 'From date',
            action: () =>
              this.autoLoadAccount(accountId, PeriodLength.FromDate, isLIB),
          },
        ],
      },
      {
        name: `${runAccountsString} and send to ETL(s)`,
        icon: '<span class="mdi mdi-play"></span>',
        action: () =>
          this.runAccounts(
            params.api,
            accountIdsToTakeActionsAgainst,
            true,
            'CUSTODY',
            this.advancedFilterContext.reconDate as unknown as Date,
          ),
        disabled: disableAccountRun,
        tooltip: disableAccountRun
          ? `You don't have Permission to run selected account`
          : '',
      },
      {
        name: `${runAccountsString} without ETL(s)`,
        icon: '<span class="mdi mdi-play"></span>',
        action: () =>
          this.runAccounts(
            params.api,
            accountIdsToTakeActionsAgainst,
            false,
            'CUSTODY',
            this.advancedFilterContext.reconDate as unknown as Date,
          ),
        disabled: disableAccountRunWithoutEtl,
        tooltip: disableAccountRunWithoutEtl
          ? `You don't have Permission to run selected account`
          : '',
      },

      {
        name: `${runAccountsString} and send to Trading ETL(s)`,
        icon: '<span class="mdi mdi-play"></span>',
        action: () =>
          this.runAccounts(
            params.api,
            accountIdsToTakeActionsAgainst,
            true,
            'TRADING',
            this.advancedFilterContext.reconDate as unknown as Date,
          ),
        disabled: disableAccountRun,
        tooltip: disableAccountRun
          ? `You don't have Permission to run selected account`
          : '',
      },
      {
        name: 'Activate External Data',
        action: () =>
          this.toggleBulkActivateNewerExternalDataModal(
            accountIdsToTakeActionsAgainst.join(','),
          ),
      },
      {
        name: 'Refresh Row Data',
        action: () =>
          this.accountListService
            .refreshAccount(accountId)
            .then(() =>
              this.toastService.success(
                `Refresh request successfully submitted for account ${accountId}.`,
              ),
            ),
        disabled: accountIdsToTakeActionsAgainst.length > 1,
        tooltip:
          accountIdsToTakeActionsAgainst.length > 1
            ? 'Only one account can be refreshed at a time.'
            : `Refresh all fields for account ${accountId}.`,
      },
      ...getFilterOnCellContextMenu(params),
      ...aitools,
      'separator',
      ...this.highlightService.createHighlightMenuItems(params, 'Row', [
        ContextualLabelingColors.khaki,
      ]),
      'separator',
    ]

    if (this.accessRunAI) {
      const aiReconcilerEntry = {
        name: 'Run AI Reconciler for selected accounts',
        icon: '<span class="mdi mdi-play"></span>',
        action: () => this.runAIreconciler(accountIdsToTakeActionsAgainst),
        disabled: disableAccountRun,
        tooltip: disableAccountRun
          ? `You don't have Permission to run selected account`
          : '',
      }
      result.splice(4, 0, aiReconcilerEntry)
    }

    switch (accountType) {
      case 'aggregate':
        result.push({
          name: 'Filter for simples',
          tooltip:
            'Filters the account list to include the aggregate & all simples within it.',
          action: () => {
            this.aggregateChanged.next(accountId)
          },
        })
        break
      case 'simple':
        result.push({
          name: 'Filter for aggregates',
          tooltip:
            'Filters the account list to include all of the aggregates that contain the simple.',
          subMenu: new AccountListAggregatesDropdown(
            accountId,
            this.resolver,
            this.container,
            this.aggregateChanged,
          ),
          action: () => this.filterForAggregates(accountId),
        })
        break
      case 'sleeveAggregate':
        result.push({
          name: 'Filter by sleeve portfolio',
          tooltip:
            'Filters the account list to include this parent portfolio & all sub-sleeves.',
          action: () => this.aggregateChanged.next(accountId),
        })
        break
      case 'sleeveSimple':
        result.push(
          {
            name: 'Filter by sleeve portfolio',
            tooltip:
              'Filters the account list to include the parent portfolio & all sub-sleeves.',
            action: () => this.aggregateChanged.next(data.sleeveAggregateId),
          },
          {
            name: 'Filter for aggregates',
            tooltip:
              'Filters the account list to include all of the aggregates that contain the simple.',
            subMenu: new AccountListAggregatesDropdown(
              accountId,
              this.resolver,
              this.container,
              this.aggregateChanged,
              data.sleeveAggregateId,
            ),
            action: () =>
              this.filterForAggregates(accountId, data.sleeveAggregateId),
          },
        )
        break
      default:
        //NOOP
        break
    }

    result.push(
      ...getCommentaryContextMenuItems(
        this.store,
        this.hasAccessCommentary,
        accountCommentary,
        data,
      ),
    )

    return result
  }

  exportToExcel() {
    const tableFilters = this.api?.getFilterModel()
    let filters
    if (tableFilters) filters = convertFilters(tableFilters)
    const fields: string[] = []
    const colHeaderNames: string[] = []
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

    this.columnApi?.getAllDisplayedColumns().forEach(col => {
      const field = col.getColId()
      if (field === COMMENTARY_COLUMN_ID) return
      fields.push(field)
      const headerName = col.getUserProvidedColDef()?.headerName
      if (headerName) colHeaderNames.push(headerName)
    })

    const request: ExportExcelRequest = {
      fields: fields,
      headers: colHeaderNames,
      filters: filters as FilterModel,
      userTimeZone: userTimeZone,
      context: {
        filterContext: {
          ...this.advancedFilterContext,
          reconDate: this.advancedFilterContext.reconDate,
        },
      } as AccountsRequestContext,
    }

    this.accountListService.getAccountsExportExcel(request).subscribe(
      response => {
        downloadExcelFile(response, 'accounts')
        this.toastService.success(
          "Export to Excel completed successfully. The exported file is available in your browser's Downloads",
          {
            closeButton: true,
            timeOut: 3000,
          },
        )
      },
      () => {
        this.toastService.error(
          'Export to Excel failed. Please try again.',
          '',
          {
            closeButton: true,
            timeOut: 3000,
            disableTimeOut: false,
          },
        )
      },
    )
    this.toastService.warning(
      'Export to Excel is in progress. It may take more than 30 seconds. Please wait.',
      {
        closeButton: true,
        timeOut: 3000,
      },
      'In Progress',
    )
  }

  runAIreconciler(selectedAccountIds: number[]) {
    const selectedReconDate = this.reconDateControl.value
    const promises: Promise<unknown>[] = []

    selectedAccountIds.forEach(accountId => {
      promises.push(
        this.accountListService
          .runAIForAccount({ accountId, reconDate: selectedReconDate })
          .toPromise(),
      )
    })
    Promise.all(promises)
      .then(() => {
        this.toastService.success(
          'AI Reconciler run Submitted Successfully for account(s) : [' +
            selectedAccountIds +
            '] and reconDate : ' +
            selectedReconDate,
          {
            closeButton: true,
            timeOut: 3000,
          },
        )
      })
      .catch((res: HttpErrorResponse) => {
        this.toastService.error(
          'AI Reconciler run failed for account(s) : [' +
            selectedAccountIds +
            '] and reconDate : ' +
            selectedReconDate,
          res.error,
          {
            closeButton: true,
            timeOut: 5000,
            disableTimeOut: false,
          },
        )
      })
  }

  toggleBulkActivateNewerExternalDataModal(selectedAccountIds: string) {
    const compKey = 'bulk-activate-newer-external-data'
    const uniqueId = compKey + '-' + Date.now()

    const modalRef = this.modalService.open(
      BulkActivateNewerExternalDataComponent,
      {
        size: 'md',
        windowClass: `modal-window-click-through ${uniqueId}`,
        backdrop: false,
        keyboard: false,
        beforeDismiss: () => {
          return this.modalPositionService.handleModalPositionSaveOnDismiss(
            uniqueId,
            compKey,
          )
        },
      } as NgbModalOptions,
    )
    modalRef.componentInstance.selectedAccountIds = selectedAccountIds
    this.modalPositionService.handleModalPositionSetup(uniqueId, compKey)
  }

  getAccountsSetValuesFilterParams(key: keyof AccountsSetValues) {
    return {
      filter: 'agSetColumnFilter',
      filterParams: {
        refreshValuesOnOpen: true,
        defaultToNothingSelected: true,
        values: params => {
          this.accountsSetValues$.subscribe(values =>
            params.success(values[key] ?? []),
          )
        },
        buttons: ['apply', 'reset'],
      } as ISetFilterParams,
    }
  }

  getAccountsSetValuesPerseusRunStatus() {
    return {
      filter: 'agSetColumnFilter',
      filterParams: {
        refreshValuesOnOpen: true,
        defaultToNothingSelected: true,
        cellRenderer: reconRunStatusTypesCellRendererWithText,
        values: params => {
          this.accountsSetValues$.subscribe(values => {
            return params.success(values.perseusRunStatus)
          })
        },
        buttons: ['apply', 'reset'],
      } as ISetFilterParams,
    }
  }

  private advancedFilterContextChanged(
    advancedFilterContext: AdvancedFilterContext,
  ) {
    this.isExternalFilterPresent = !isEmpty(
      advancedFilterContext.advancedFilters,
    )

    this.quickSearch.reset(
      advancedFilterContext.advancedFilters.quickSearch?.substring ?? '',
    )

    this.advancedFilterContext = {
      ...advancedFilterContext,
    }

    this.api?.onFilterChanged()
  }

  private advancedFiltersChanged(
    advancedFilters: AdvancedFilters,
    preventRevert = false,
  ) {
    const context = { ...this.advancedFilterContext }
    context.advancedFilters = { ...advancedFilters }

    this.advancedFilterContextChanged(context)

    if (!preventRevert) {
      this.revertFilterService.advancedFiltersChanged(advancedFilters)
    }
  }

  clearFilters() {
    this.quickSearch.reset('')
    this.advancedFiltersChanged({})
    this.quickSearchAccountIds.reset('')
    this.isExternalFilterPresent = false
    this.api?.setFilterModel(null)
    this.api?.onFilterChanged()
  }

  revertToPreviousFilters() {
    this.revertFilterService.revertFilters()
  }

  launchFiltersModal() {
    this.filterModalService.launchFiltersModal()
  }

  updateQuickSearchAccountIds() {
    if (!this.quickSearchAccountIds.valid) {
      return // don't update with an invalid value
    }

    setFilter<Account>(
      'accountId',
      this.quickSearchAccountIds.value
        ? {
            type: 'in',
            filterType: 'number',
            filter: this.quickSearchAccountIds.value,
          }
        : undefined,
      this.api,
    )
  }

  updateQuickFilter() {
    const { quickSearch, ...otherFilters } =
      this.advancedFilterContext.advancedFilters
    if (quickSearch?.substring !== this.quickSearch.value) {
      const updatedAdvancedFilters: AdvancedFilters = {
        ...otherFilters,
      }
      if (this.quickSearch.value) {
        updatedAdvancedFilters.quickSearch = {
          substring: this.quickSearch.value,
          substrings: this.quickSearch.value.split(', '),
        }
      }
      this.advancedFiltersChanged(updatedAdvancedFilters)
    }
  }

  updateReconDateFilter(reconDate: string) {
    if (this.reconDateControl.invalid) {
      this.isReconDateOutside = false
      this.advancedFilterContext.reconDate = ''
      return
    }

    this.isReconDateOutside = this._actualReconDate
      ? reconDate !== this._actualReconDate
      : false

    const shouldDataUpdate = ReconDateBasedFilters.some(
      filterName =>
        this.advancedFilterContext.advancedFilters[filterName] != null,
    )

    if (shouldDataUpdate || reconDate) {
      this.api?.onFilterChanged()
      this.clearFiltersEnabled = true
    }
    this.store.dispatch(
      setSelectedReconDate({
        selectedReconDate: reconDate as unknown as Date,
      }),
    )
  }

  //#region GridConfig
  /**
   * @internal
   */
  async createGridOptions(): Promise<GridOptions> {
    return {
      columnDefs: await this.createColumnDefs(),
      components: {
        [commentCountRendererKey]: CommentCountCellRenderer,
      },
      ...heliosServerSideRowConfig,
      ...heliosMultiRowSelectionConfig,
      columnTypes: {
        ...heliosColumnTypes,
        [IssuesType]: {
          cellRenderer: issueTypeCellRenderer,
          width: heliosDefaultColWidth.MediumIcon,
          cellClass: 'issue-type-cell',
          tooltipValueGetter: params => issueTypeTooltipValueGetter(params),
        },
      },
      rowClassRules: {
        'loaded-account': (params: RowClassParams) => {
          const account: Account | undefined = params.data
          return (
            account != null &&
            account.accountId === this._session?.loadedAccountIds[0]
          )
        },
      },
      onFirstDataRendered: event => this.onFirstDataRendered(event),
      onGridReady: event => this.onGridReady(event),
      sideBar: generateHeliosAgGridSidebarFromScratch([
        createPanelSettingsToolPanel({
          controls: [
            {
              label: 'Clear Filters on Load',
              formControl: this.clearFiltersOnAccountLoadToggle,
            },
          ],
        }),
        ...heliosDefaultToolPanels,
        createFilterGroupsToolPanel<AdvancedFilters>(
          this.filterGroupsToolPanelParams,
        ),
      ]),
      statusBar: accountListStatusBarPanel,
      serverSideDatasource: this.createDatasource(),
      getRowNodeId: ({ accountId }: Account) => accountId.toString(),
      getContextMenuItems: params => this.getContextMenuItems(params),
      onSelectionChanged: event => this.onRowSelectionChanged(event),
      onModelUpdated: (event: ModelUpdatedEvent) => {
        const baseOnModelUpdated = heliosServerSideRowConfig.onModelUpdated
        if (baseOnModelUpdated != null) baseOnModelUpdated(event)
        this.updateRelatedSleeveAccountHighlighting(event.api)
      },
      getRowClass: params => [
        this.highlightService.getRowClass(params?.node?.id ?? ''),
        `${AccountListMainGridKey}-${params.node.id}`,
        AccountListMainGridRowClass,
      ],
      icons: {
        panelSettings: generateMdiIcon('mdi-cog'),
      },
      onRowDoubleClicked: event =>
        this.onRowDoubleClicked(event.data as Account),
      isExternalFilterPresent: () => this.isExternalFilterPresent,
      onColumnVisible: params =>
        handleColumnVisibilityChange(params, 'AccountList'),
      ...disableChangeDetectionOnScroll(this.changeDetector),
      context: {
        resolver: this.resolver,
        changeDetector: this.changeDetector,
        accountListService: this.accountListService,
        userPreferencesService: this.preferences,
        store: this.store,
        configureBellModalService: this.configureBellModalService,
        getRowCountRequest: (api: GridApi) =>
          getAccountRowCountRequest(api, this.advancedFilterContext),
        setBellFilters: (type: keyof Account, accountOwners: string[]) =>
          this.setBellFilters(type, accountOwners),
        getAccountSetValues: () =>
          this.accountsSetValues$.pipe(take(1)).toPromise(),
      },
    }
  }

  /**
   * @internal
   */
  async createColumnDefs(): Promise<ColDef[]> {
    const reconDateRangeErrorMsg =
      'WARNING: Historic timestamp data is not available in Helios for the selected Recon Date. Runs can still be submitted and will behave as normal.'
    const baseColDefs: ColDef[] = [
      // Comments column — pinned-left chat icon + thread count, click
      // opens the drawer scoped to that account. Omitted entirely for users
      // without commentary access — see getCommentaryColumnIfAccessible.
      ...(await getCommentaryColumnIfAccessible(
        this.store,
        accountCommentary,
        () => this.hasAccessCommentary,
        this.commentaryCountsService,
        accountCounts,
      )),
      {
        field: accountPath('accountUsers'),
        headerName: 'Users in account',
        width: heliosDefaultColWidth.SmallIcon,
        filter: false,
        sortable: true,
        cellRenderer: params =>
          usersInAccountCellRenderer(params, this.currentUser?.nickname),
        tooltipValueGetter: params => {
          const { accountUsers } = params.data ?? {}
          const users = Array.isArray(accountUsers)
            ? accountUsers.join(', ')
            : ''

          return users
        },
        tooltipComponentParams: {
          showTooltip: () => true,
        } as NfTooltipParams,
      },
      {
        ...this.getAccountsSetValuesFilterParams('accountTypes'),
        field: accountPath('accountType'),
        headerName: 'Account Type',
        width: heliosDefaultColWidth.SmallIcon,
        cellRenderer: params => accountTypes.get(params.value)?.icon ?? '',
        tooltipValueGetter: params =>
          accountTypes.get(params.value)?.toolTip ?? '',
        tooltipComponentParams: {
          showTooltip: () => true,
        } as NfTooltipParams,
        sortable: true,
        filterParams: {
          cellRenderer: accountTypesFilterCellRenderer,
          values: params => {
            this.accountsSetValues$.subscribe(values =>
              params.success(values.accountTypes),
            )
          },
        } as ISetFilterParams,
      },
      {
        field: accountPath('accountId'),
        headerName: 'Account ID',
        width: heliosDefaultColWidth.Id,
        type: NfColumnTypes.Identifier,
        valueFormatter: undefined,
        sortable: true,
        filterParams: {
          filterOptions: NumberFilterOptionsWithoutEquals,
        },
      },
      {
        field: accountPath('accountName'),
        headerName: 'Account Name',
        sortable: true,
        filterParams: {
          filterOptions: TextFilterOptionsWithContainsIn,
        },
      },
      {
        ...this.getAccountsSetValuesFilterParams('accountBases'),
        field: accountPath('accountBasis'),
        headerName: 'Account Basis',
        sortable: false,
      },
      {
        field: accountPath('clientId'),
        headerName: 'Client ID',
        type: NfColumnTypes.Identifier,
        valueFormatter: undefined,
        initialHide: true,
        sortable: true,
        filterParams: {
          filterOptions: NumberFilterOptionsWithAbsolute,
        },
      },
      {
        ...this.getAccountsSetValuesFilterParams('clients'),
        field: accountPath('clientName'),
        headerName: 'Client Name',
        sortable: true,
      },
      {
        ...this.getAccountsSetValuesFilterParams('sleeveAggregateIds'),
        field: accountPath('sleeveAggregateId'),
        headerName: 'Parent Portfolio Account ID',
        sortable: true,
        type: NfColumnTypes.Identifier,
        width: heliosDefaultColWidth.Id,
      },
      {
        ...this.getAccountsSetValuesFilterParams('opsManagers'),
        field: accountPath('opsManager'),
        headerName: 'Ops Manager',
        sortable: true,
      },
      {
        ...this.getAccountsSetValuesFilterParams('reconcilers'),
        field: accountPath('reconciler'),
        headerName: 'Reconciler',
        sortable: true,
      },
      {
        ...this.getAccountsSetValuesFilterParams('managers'),
        field: accountPath('manager'),
        headerName: 'Manager',
        sortable: true,
      },
      {
        ...this.getAccountsSetValuesFilterParams('securityTypes'),
        field: accountPath('secTypes'),
        headerName: 'Sec Types',
        sortable: false,
      },
      {
        field: accountPath('lastPerseusRunEtlState'),
        headerName: 'Last Run With ETLs',
        initialHide: false,
        type: HeliosColumnTypes.Boolean,
      },
      {
        field: accountPath('lastPerseusRun'),
        headerName: 'Last Recon Run',
        type: HeliosColumnTypes.ShortDateTime,
        sortable: true,
        tooltipValueGetter: params => {
          return formatDateTime(params.value)
        },
      },
      {
        field: accountPath('lastPerseusRunReconDate'),
        headerName: 'Last Recon Run Recon Date',
        type: NfColumnTypes.Date,
        width: heliosDefaultColWidth.DateCol,
        sortable: true,
        valueFormatter: params => {
          return formatDates(params.value, 'yyyy-MM-dd', 'MM/dd/yy')
        },
        tooltipValueGetter: params => {
          return formatDates(params.value, 'yyyy-MM-dd', 'MM/dd/yyyy')
        },
      },
      {
        field: accountPath('lastPerseusRunOmegaAchieved'),
        headerName: 'Last Recon Run Omega Achieved',
        type: HeliosColumnTypes.Boolean,
        sortable: true,
      },
      {
        field: accountPath('securityCreationIssues'),
        headerName: 'Sec',
        headerTooltip: 'Security Creation Issues',
        type: IssuesType,
        filter: false,
        sortable: true,
      },
      {
        field: accountPath('transactionBreaksIssues'),
        headerName: 'Tran',
        headerTooltip: 'Transaction Breaks Issues',
        type: IssuesType,
        filter: false,
        sortable: true,
      },
      {
        field: accountPath('positionIssues'),
        headerName: 'Pos',
        headerTooltip: 'Position Issues',
        type: IssuesType,
        filter: false,
        sortable: true,
      },
      {
        field: accountPath('lotEntryAndExitIssues'),
        headerName: 'Lot',
        headerTooltip: 'Lot Entry and Exit Issues',
        type: IssuesType,
        filter: false,
        sortable: true,
      },
      {
        field: accountPath('distributionIssues'),
        headerName: 'Dist',
        headerTooltip: 'Distribution Issues',
        type: IssuesType,
        filter: false,
        sortable: true,
      },
      {
        field: accountPath('transactionDataIntegrityIssues'),
        headerName: 'Integ',
        headerTooltip: 'Transaction Data Integrity Issues',
        type: IssuesType,
        filter: false,
        sortable: true,
      },
      {
        field: accountPath('priceAndAnalyticsIssues'),
        headerName: 'Price',
        headerTooltip: 'Price and Analytics Issues',
        type: IssuesType,
        filter: false,
        sortable: true,
      },
      {
        field: accountPath('corporateActionsIssues'),
        headerName: 'CA',
        headerTooltip: 'Corporate Actions Issues',
        type: IssuesType,
        filter: false,
        sortable: true,
      },
      {
        field: accountPath('elmIssues'),
        headerName: 'ELM',
        headerTooltip: 'External Lot Management Issues',
        type: IssuesType,
        filter: false,
        sortable: true,
      },
      {
        field: accountPath('amortizationIssues'),
        headerName: 'Amort',
        headerTooltip: 'Amortization Issues',
        type: IssuesType,
        filter: false,
        sortable: true,
      },
      {
        field: accountPath('otherIssues'),
        headerName: 'Other Issues',
        type: IssuesType,
        filter: false,
        sortable: true,
      },
      {
        field: accountPath('complianceViolations'),
        headerName: 'Compliance Violations',
        type: NfColumnTypes.Integer,
        cellRenderer: complianceViolationCellRenderer,
        width: 40,
        sortable: true,
        filterParams: {
          filterOptions: NumberFilterOptionsWithAbsolute,
        },
      },
      {
        field: accountPath('highPriorityTotal'),
        headerName: 'High Priority Total',
        sortable: true,
        type: NfColumnTypes.Integer,
        width: heliosDefaultColWidth.MediumIcon,
        filterParams: {
          filterOptions: NumberFilterOptionsWithAbsolute,
        },
      },
      {
        field: accountPath('mediumPriorityTotal'),
        headerName: 'Medium Priority Total',
        sortable: true,
        type: NfColumnTypes.Integer,
        width: heliosDefaultColWidth.MediumIcon,
        filterParams: {
          filterOptions: NumberFilterOptionsWithAbsolute,
        },
      },
      {
        field: accountPath('heldPriorityTotal'),
        headerName: 'Held Total',
        sortable: true,
        type: NfColumnTypes.Integer,
        width: heliosDefaultColWidth.MediumIcon,
        filterParams: {
          filterOptions: NumberFilterOptionsWithAbsolute,
        },
      },
      {
        field: accountPath('omegaDate'),
        headerName: 'Omega Date',
        type: NfColumnTypes.Date,
        width: heliosDefaultColWidth.DateCol,
        sortable: true,
        valueFormatter: params => {
          return formatDates(params.value, 'yyyy-MM-dd', 'MM/dd/yy')
        },
        tooltipValueGetter: params => {
          return formatDates(params.value, 'yyyy-MM-dd', 'MM/dd/yyyy')
        },
      },
      {
        field: accountPath('custodyAccountNumber'),
        headerName: 'Custody Account ID',
        sortable: true,
        filterParams: {
          filterOptions: TextFilterOptionsWithContainsIn,
        },
      },
      {
        field: accountPath('custodyDataFeeds'),
        headerName: 'Custody Data Feeds',
        initialHide: true,
        sortable: true,
        filterParams: {
          filterOptions: TextFilterOptionsWithContainsIn,
        },
      },
      {
        field: accountPath('tradingDataFeeds'),
        headerName: 'Trading Data Feeds',
        initialHide: true,
        sortable: true,
        filterParams: {
          filterOptions: TextFilterOptionsWithContainsIn,
        },
      },
      {
        ...this.getAccountsSetValuesFilterParams('priorities'),
        field: accountPath('priority'),
        headerName: 'Priority',
        initialHide: true,
        cellRenderer: priorityCellRenderer,
        tooltipValueGetter: params => this.capitalizeFirstLetter(params.value),
        tooltipComponentParams: {
          showTooltip: () => true,
        } as NfTooltipParams,
        width: heliosDefaultColWidth.SmallIcon,
        sortable: true,
      },
      {
        field: accountPath('nextLockdown'),
        headerName: 'Next Lockdown',
        initialHide: true,
        type: NfColumnTypes.Date,
        width: heliosDefaultColWidth.DateCol,
        sortable: true,
        valueFormatter: params => {
          return formatDates(params.value, 'yyyy-MM-dd', 'MM/dd/yy')
        },
        tooltipValueGetter: params => {
          return formatDates(params.value, 'yyyy-MM-dd', 'MM/dd/yyyy')
        },
      },
      {
        field: accountPath('isStable'),
        headerName: 'Stable',
        initialHide: true,
        sortable: true,
        type: HeliosColumnTypes.Boolean,
      },
      {
        field: accountPath('etlLockedDate'),
        headerName: 'Etl Locked Date',
        initialHide: true,
        type: NfColumnTypes.Date,
        width: heliosDefaultColWidth.DateCol,
        sortable: true,
        valueFormatter: params => {
          return formatDates(params.value, 'yyyy-MM-dd', 'MM/dd/yy')
        },
        tooltipValueGetter: params => {
          return formatDates(params.value, 'yyyy-MM-dd', 'MM/dd/yyyy')
        },
      },
      {
        field: accountPath('isReconciling'),
        headerName: 'Reconciling',
        sortable: true,
        initialHide: true,
        type: HeliosColumnTypes.Boolean,
      },
      {
        field: accountPath('isMirrored'),
        headerName: 'Mirrored',
        initialHide: true,
        sortable: true,
        type: HeliosColumnTypes.Boolean,
      },
      {
        field: accountPath('isTriparty'),
        headerName: 'Triparty',
        initialHide: true,
        sortable: true,
        type: HeliosColumnTypes.Boolean,
      },
      {
        field: accountPath('isAutomaticEtlRun'),
        headerName: 'Automatic Etl Run',
        initialHide: true,
        sortable: true,
        type: HeliosColumnTypes.Boolean,
      },
      {
        field: accountPath('isDemo'),
        headerName: 'Demo',
        initialHide: true,
        sortable: true,
        type: HeliosColumnTypes.Boolean,
      },
      {
        field: accountPath('isLIB'),
        headerName: 'LIB',
        initialHide: true,
        sortable: true,
        type: HeliosColumnTypes.Boolean,
      },
      {
        field: accountPath('bloombergDataEnabled'),
        headerName: 'Bloomberg Data Enabled',
        initialHide: true,
        sortable: true,
        type: HeliosColumnTypes.Boolean,
      },
      {
        ...this.getAccountsSetValuesFilterParams('externalReferenceSources'),
        field: accountPath('externalReferenceSource'),
        headerName: 'External Reference Source',
        initialHide: true,
        sortable: true,
      },
      {
        field: accountPath('libStartDate'),
        headerName: 'LIB Start Date',
        type: NfColumnTypes.Date,
        width: heliosDefaultColWidth.DateCol,
        sortable: true,
        valueFormatter: params => {
          return formatDates(params.value, 'yyyy-MM-dd', 'MM/dd/yy')
        },
        tooltipValueGetter: params => {
          return formatDates(params.value, 'yyyy-MM-dd', 'MM/dd/yyyy')
        },
      },
      {
        field: accountPath('traderCodes'),
        headerName: 'Trade Codes',
        initialHide: true,
        sortable: true,
      },
      {
        field: accountPath('contractualDeadline'),
        headerName: 'Contractual Deadline',
        type: HeliosColumnTypes.Time,
        sortable: true,
      },
      {
        field: accountPath('preferredDeadline'),
        headerName: 'Preferred Deadline',
        type: HeliosColumnTypes.Time,
        sortable: true,
      },
      {
        ...this.getAccountsSetValuesFilterParams('secondaryReps'),
        field: accountPath('secondaryRep'),
        headerName: 'Secondary Rep',
        initialHide: true,
        sortable: true,
      },
      {
        field: accountPath('custodyReconciled'),
        headerName: 'Custody Reconciled',
        type: NfColumnTypes.Date,
        width: heliosDefaultColWidth.DateCol,
        sortable: true,
        editable: this.isReconDateWithinLast7Days,
        cellClass: () =>
          !this.isReconDateWithinLast7Days ? 'disable-recon-cols' : '',
        valueFormatter: params => {
          return formatDates(params.value, 'yyyy-MM-dd', 'MM/dd/yy')
        },
        tooltipValueGetter: params =>
          !this.isReconDateWithinLast7Days && !params.data.custodyReconciled
            ? reconDateRangeErrorMsg
            : params.data.custodyReconciled,
      },
      {
        field: accountPath('tradingReconciled'),
        headerName: 'Trading Reconciled',
        type: NfColumnTypes.Date,
        width: heliosDefaultColWidth.DateCol,
        sortable: true,
        editable: this.isReconDateWithinLast7Days,
        cellClass: () =>
          !this.isReconDateWithinLast7Days ? 'disable-recon-cols' : '',
        valueFormatter: params => {
          return formatDates(params.value, 'yyyy-MM-dd', 'MM/dd/yy')
        },
        tooltipValueGetter: params =>
          !this.isReconDateWithinLast7Days && !params.data.tradingReconciled
            ? reconDateRangeErrorMsg
            : params.data.tradingReconciled,
      },
      {
        field: accountPath('externalCustody'),
        headerName: 'External Custody',
        type: HeliosColumnTypes.ShortDateTime,
        sortable: true,
        editable: this.isReconDateWithinLast7Days,
        cellClass: () =>
          !this.isReconDateWithinLast7Days ? 'disable-recon-cols' : '',
        tooltipValueGetter: params =>
          !this.isReconDateWithinLast7Days && !params.data.externalCustody
            ? reconDateRangeErrorMsg
            : formatDateTime(params.data.externalCustody),
      },
      {
        field: accountPath('externalTrading'),
        headerName: 'External Trading',
        type: HeliosColumnTypes.ShortDateTime,
        sortable: true,
        editable: this.isReconDateWithinLast7Days,
        cellClass: () =>
          !this.isReconDateWithinLast7Days ? 'disable-recon-cols' : '',

        tooltipValueGetter: params =>
          !this.isReconDateWithinLast7Days && !params.data.externalTrading
            ? reconDateRangeErrorMsg
            : formatDateTime(params.data.externalTrading),
      },
      {
        ...getBooleanTypeCellRenderer('mdi-shield-check'),
        field: accountPath('hasComplianceTimestamp'),
        headerName: 'Compliance Timestamp',
        initialHide: true,
      },
      {
        ...getBooleanTypeCellRenderer('mdi-currency-usd'),
        field: accountPath('hasPricingRun'),
        headerName: 'Pricing Run Complete',
        initialHide: true,
        sortable: true,
        editable: this.isReconDateWithinLast7Days,
        cellClass: () =>
          !this.isReconDateWithinLast7Days ? 'disable-recon-cols' : '',
        tooltipValueGetter: params =>
          !this.isReconDateWithinLast7Days && !params.data.hasPricingRun
            ? reconDateRangeErrorMsg
            : params.data.hasPricingRun,
      },
      {
        ...this.getAccountsSetValuesPerseusRunStatus(),
        field: accountPath('perseusRunStatus'),
        headerName: 'Recon Run Status',
        cellRenderer: reconRunStatusTypesCellRenderer,
        tooltipValueGetter: params => params.value,
        tooltipComponentParams: {
          showTooltip: () => true,
        } as NfTooltipParams,
        width: heliosDefaultColWidth.LargeIcon,
        sortable: true,
      },
      {
        field: accountPath('parentClientId'),
        headerName: 'Ult Parent Client ID',
        type: NfColumnTypes.Identifier,
        sortable: true,
        filterParams: {
          filterOptions: NumberFilterOptionsWithAbsolute,
        },
      },
      {
        ...this.getAccountsSetValuesFilterParams('parentClients'),
        field: accountPath('parentClientName'),
        headerName: 'Ult Parent',
        sortable: true,
      },
      {
        type: HeliosColumnTypes.ShortDateTime,
        field: accountPath('reconTimestamp'),
        headerName: 'Recon Timestamp',
        sortable: true,
        editable: this.isReconDateWithinLast7Days,
        cellClass: () =>
          !this.isReconDateWithinLast7Days ? 'disable-recon-cols' : '',
        tooltipValueGetter: params => {
          return !this.isReconDateWithinLast7Days &&
            !params.data.hasCustodyTimestamp
            ? reconDateRangeErrorMsg
            : formatDateTime(params.data.hasCustodyTimestamp)
        },
      },
      {
        ...getBooleanTypeCellRenderer('mdi-check-outline'),
        field: accountPath('hasOmegaDateToday'),
        headerName: 'Omega Date Today',
        initialHide: true,
        sortable: true,
      },
      {
        field: accountPath('maxCustodyReconciled'),
        headerName: 'Most Recent Custody Reconciled Date',
        type: NfColumnTypes.Date,
        initialHide: true,
        sortable: true,
        valueFormatter: params => {
          return formatDates(params.value, 'yyyy-MM-dd', 'MM/dd/yy')
        },
        tooltipValueGetter: params => {
          return formatDates(params.value, 'yyyy-MM-dd', 'MM/dd/yyyy')
        },
      },
      {
        field: accountPath('maxTradingReconciled'),
        headerName: 'Most Recent Trading Reconciled Date',
        type: NfColumnTypes.Date,
        sortable: true,
        initialHide: true,
        valueFormatter: params => {
          return formatDates(params.value, 'yyyy-MM-dd', 'MM/dd/yy')
        },
        tooltipValueGetter: params => {
          return formatDates(params.value, 'yyyy-MM-dd', 'MM/dd/yyyy')
        },
      },
      {
        field: accountPath('latestCustodyExecutionActive'),
        headerName: 'Latest Custody Execution Active',
        type: HeliosColumnTypes.Boolean,
        editable: this.isReconDateWithinLast7Days,
        cellClass: () =>
          !this.isReconDateWithinLast7Days ? 'disable-recon-cols' : '',
      },
      {
        field: accountPath('latestTradingExecutionActive'),
        headerName: 'Latest Trading Execution Active',
        type: HeliosColumnTypes.Boolean,
        editable: this.isReconDateWithinLast7Days,
        cellClass: () =>
          !this.isReconDateWithinLast7Days ? 'disable-recon-cols' : '',
      },
      {
        field: accountPath('custodyBankName'),
        headerName: 'Custody Bank',
        sortable: true,
      },
      {
        field: accountPath('startDate'),
        headerName: 'Account Start Date',
        type: NfColumnTypes.Date,
        width: heliosDefaultColWidth.DateCol,
        sortable: true,
        valueFormatter: params => {
          return formatDates(params.value, 'yyyy-MM-dd', 'MM/dd/yy')
        },
        tooltipValueGetter: params => {
          return formatDates(params.value, 'yyyy-MM-dd', 'MM/dd/yyyy')
        },
      },
      {
        field: accountPath('implementationCompleteDate'),
        headerName: 'Implementation Complete Date',
        type: NfColumnTypes.Date,
        width: heliosDefaultColWidth.DateCol,
        sortable: true,
        valueFormatter: params => {
          return formatDates(params.value, 'yyyy-MM-dd', 'MM/dd/yy')
        },
        tooltipValueGetter: params => {
          return formatDates(params.value, 'yyyy-MM-dd', 'MM/dd/yyyy')
        },
      },
    ]

    const savedViewExists = await this.store
      .pipe(
        selectSavedViewExistsForGridKey(AccountListMainGridKey),
        takeUntil(this.destroySubject$),
        take(1),
      )
      .toPromise()

    if (!savedViewExists) {
      return baseColDefs
    }

    const savedColumnState = await this.store
      .pipe(
        takeUntil(this.destroySubject$),
        selectActiveSavedViewForGrid(AccountListMainGridKey),
        take(1),
        map(savedView => savedView.savedView.columnState),
      )
      .toPromise()

    return mergeBaseColDefsWithColumnState(baseColDefs, savedColumnState)
  }

  /*@internal*/
  capitalizeFirstLetter(string: string) {
    if (!string) {
      return ''
    }

    return string.charAt(0).toUpperCase() + string.slice(1)
  }

  private createDatasource(): IServerSideDatasource {
    return {
      getRows: (params: IServerSideGetRowsParams) => {
        try {
          convertToTimeFilters(params.request.filterModel, [
            'contractualDeadline',
            'preferredDeadline',
          ])

          const advancedFilterApplied =
            this.advancedFilterContext.advancedFilters
          this.filterCount =
            countFilters(
              params.api,
              advancedFilterApplied as Record<string, unknown>,
            ) ?? 0

          const request = toHeliosRequest<Account, AccountsRequestContext>(
            params,
            [],
            accountCommentary.mandatoryFields(
              'accountType',
              'sleeveAggregateId',
              'isLIB',
              'accountBasis',
            ),
            {
              filterContext: {
                ...this.advancedFilterContext,
                reconDate: this.advancedFilterContext.reconDate,
              },
            } as AccountsRequestContext,
          )

          this.accountListService
            .getAccounts(request)
            .pipe(
              tap(accounts => {
                const totalRows =
                  (params?.request?.startRow ?? 0) + accounts.length
                params.success({
                  rowData: accounts,
                  rowCount:
                    totalRows < (params?.request?.endRow ?? totalRows)
                      ? totalRows
                      : undefined,
                })
              }),
              tap(() => {
                const accountIds: number[] = []
                this.api?.forEachNode(node => {
                  if (!node.data?.accountId) {
                    return
                  }

                  accountIds.push(node.data.accountId)
                })
                this.onAccountsInViewChange.next(accountIds)
              }),
            )
            .subscribe()

          // check if recon date is within 7 days or not
          this.isReconDateWithinLast7Days = checkIfDateIsWithinRange(
            formatDate(this.advancedFilterContext.reconDate, ISODateFormat),
            7,
          )
        } catch (e) {
          params.fail()
        }
      },
    }
  }

  /**
   * When a new session is loaded or updates are made to the data we should get the set values again.
   * @private
   */
  private resetAccountsSetValues() {
    this.accountsSetValues$ = this.getAccountsSetValues()
  }

  private getAccountsSetValues() {
    return this.accountListService
      .getAccountsSetValues()
      .pipe(take(1), shareReplay(1))
  }

  private async onGridReady(event: GridReadyEvent) {
    const { api, columnApi } = event

    this.api = api
    this.columnApi = columnApi
    this.api.addEventListener(Events.EVENT_FILTER_CHANGED, this.filterChanged)

    this.setupRevertFilters()

    wireCommentaryCounts<Account>({
      changes$: this.commentaryCountsService.changes$,
      getApi: () => api,
      hasAccessForLoad: () => this.hasAccessCommentary,
      destroy$: this.destroySubject$,
      accountIdOf: row => row?.accountId,
      loadCounts: ids => this.commentaryCountsService.ensureAccountsLoaded(ids),
      live: { accounts: this.commentaryLiveAccounts, surface: 'total' },
    })
    refilterOnThreadChanges<Account>(() => api, this.destroySubject$, {
      accountIdOf: row => row?.accountId,
    })

    enableHeliosMultiRowDragSelection(api)
    enableHeliosCopyBehavior(api)

    this.preferences
      .getDensityLevel()
      .pipe(takeUntil(this.destroySubject$))
      .subscribe(level =>
        enableHeliosGridDensityLevel(api, DensityLevel.Compact === level),
      )

    this.filterModalService
      .registerGrid(
        api,
        AccountListKey,
        AccountListMainGridKey,
        [COMMENTARY_COLUMN_ID],
        AdvancedFiltersComponent,
        () => ({
          context: this.advancedFilterContext,
        }),
      )
      .pipe(
        takeUntil(this.destroySubject$),
        map(
          x =>
            x as FilterModalEvent<AdvancedOptionsParams<AdvancedFilterContext>>,
        ),
      )
      .subscribe(e => {
        this.reconDateControl.setValue(e.payload.context.reconDate)
        this.advancedFiltersChanged(e.payload.context.advancedFilters)
      })

    /* why move this later ? so that all filter change events are called before workspace is rendered and only if workspace
    has filter model it ever again calls filter model change not otherwise avoiding unnecessary race conditions */
    const agGridStateSaved = await this.savedViewService.manageSavedView(
      event,
      AccountListMainGridKey,
      this.destroySubject$,
      true,
      this.getCurrentPanelSettingsObject(),
    )

    this.applyGridConfig(agGridStateSaved)
    refreshSetValuesForAllSetFilterColumns(event)
  }

  private setupRevertFilters() {
    this.revertFilterService.setupRevertFilter(this.api)
    this.revertFilterService.advancedFiltersChanged$
      .pipe(takeUntil(this.destroySubject$))
      .subscribe(advancedFilterState => {
        this.advancedFilterContext.advancedFilters = advancedFilterState
        this.advancedFiltersChanged(advancedFilterState, true)
      })

    this.revertFilterService.onRevertFilters$
      .pipe(takeUntil(this.destroySubject$))
      .subscribe(filters => {
        const accountId = (filters.grid.accountId ?? { filter: '' }) as {
          filter: ''
        }
        this.quickSearchAccountIds.setValue(accountId.filter, {
          emitEvent: false,
        })
      })
  }

  private async onFirstDataRendered(event: FirstDataRenderedEvent) {
    this._isRendered = true
    await this.highlightService.setGridKeyForPersistentStorage(
      AccountListMainGridKey,
      this.keyValueUiStorageService,
      event.api,
    )
  }
  //#endregion GridConfig

  private fetchCommands(): Promise<Command[] | undefined> {
    return this.commandService
      .getCommands(this._session!.id)
      .pipe(take(1), takeUntil(this.destroySubject$))
      .toPromise()
  }

  /**
   * @internal
   * @param api
   * @param accountIds
   * @param runEtls
   * @param reconDate
   */
  async runAccounts(
    api: GridApi,
    accountIds: number[],
    runEtls: boolean,
    runType: RunType,
    reconDate: Date,
  ) {
    const commands = this._session?.id ? await this.fetchCommands() : null

    if (commands === undefined) return

    // If there are no commands, use the original approach
    if (commands === null || commands.length === 0) {
      for (const id of accountIds) {
        this.updatePerseusRunStatus(
          api,
          id,
          runEtls ? ReconRunStatus.READY_ETLS : ReconRunStatus.READY,
        )
      }
      return this.commandService
        .run(accountIds, runEtls, reconDate, runType)
        .catch(() => {
          for (const id of accountIds) {
            this.updatePerseusRunStatus(api, id)
          }
        })
    }

    // Build a set of account IDs that have at least one needsReview command
    const reviewAccountIds = new Set<number>(
      commands.filter(cmd => cmd.needsReview).map(cmd => cmd.command.accountId),
    )

    const accountsWithReview = accountIds.filter(id => reviewAccountIds.has(id))
    const accountsWithoutReview = accountIds.filter(
      id => !reviewAccountIds.has(id),
    )

    const runWithoutReview = async () => {
      if (accountsWithoutReview.length === 0) return
      for (const id of accountsWithoutReview) {
        this.updatePerseusRunStatus(
          api,
          id,
          runEtls ? ReconRunStatus.READY_ETLS : ReconRunStatus.READY,
        )
      }
      try {
        await this.commandService.run(
          accountsWithoutReview,
          runEtls,
          reconDate,
          runType,
        )
      } catch (error) {
        for (const id of accountsWithoutReview) {
          this.updatePerseusRunStatus(api, id)
        }
      }
    }

    const runWithReview = async () => {
      if (accountsWithReview.length === 0) return
      // Show one modal for all restricted commands across all review accounts
      const allReviewCommands = commands.filter(cmd => cmd.needsReview)

      const message =
        this.commandService.buildRestrictedActionConfirmationMessage(
          allReviewCommands.length,
        )
      const confirmed = await this.genericConfirmationModalService.warning(
        message,
        'Approval Required',
      )

      if (!confirmed) {
        return
      }

      // Submit all review accounts in parallel, aggregate results for toast
      const results = await Promise.all(
        accountsWithReview.map(async accountId => {
          if (this.commandService.checkForDuplicateCreateRequest(accountId)) {
            return null
          }
          const accountCommands = commands.filter(
            cmd => cmd.command.accountId === accountId,
          )
          try {
            await this.handleReviewCommandsConfirmation(
              api,
              accountId,
              accountCommands,
              runEtls,
              runType,
              reconDate,
            )
            return true
          } catch {
            return false
          }
        }),
      )

      const failedCount = results.filter(r => r === false).length
      const successCount = results.filter(r => r === true).length
      if (failedCount > 0) {
        this.toastService.error(
          `${failedCount} account(s) failed to submit approval commands`,
        )
      } else if (successCount > 0) {
        this.toastService.success('Commands are pending on approvals panel')
      }
    }

    await Promise.all([runWithoutReview(), runWithReview()])
  }

  /**
   * Handles the confirmation and submission of review commands
   *
   * @param api Grid API instance
   * @param accountId Account ID that needs review
   * @param commands Commands for these accounts
   * @param runEtls Whether to run ETLs
   * @param runType Run type
   * @param reconDate Reconciliation date
   * @returns Boolean indicating if the operation was confirmed and completed
   */
  private async handleReviewCommandsConfirmation(
    api: GridApi,
    accountId: number,
    commands: Command[],
    runEtls: boolean,
    runType: RunType,
    reconDate: Date,
  ): Promise<void> {
    try {
      const reconDateString = formatDate(reconDate, ISODateFormat) + ''

      const request = this.commandService.buildRestrictedActionRequest(
        commands,
        [accountId],
        reconDateString,
        this._session?.id ?? '',
        runEtls,
        runType,
        commands.length,
      )

      const response = await this.commandService
        .runRestrictedAction(request)
        .pipe(take(1))
        .toPromise()

      if (!response || (response.invalidRequests?.length ?? 0) > 0) {
        throw new Error('Commands failed to be submitted')
      }
    } catch (error) {
      this.updatePerseusRunStatus(api, accountId)
      throw error
    }
  }

  private updatePerseusRunStatus(
    api: GridApi,
    accountId: number,
    perseusRunStatus?: ReconRunStatus,
  ) {
    const node = api.getRowNode(accountId + '')
    if (node == null) return

    node.setDataValue('perseusRunStatus', perseusRunStatus)
  }

  /**
   * @internal
   * @param accountId - the simple account that we will fetch all the aggs for
   * @param parentPortfolioId - the parent portfolio that we will not include in the list
   */
  async filterForAggregates(
    accountId: number,
    parentPortfolioId?: number,
  ): Promise<void> {
    let aggregates = await this.accountListService
      .getAggregates(accountId)
      .pipe(take(1))
      .toPromise()
    if (parentPortfolioId != null)
      aggregates = aggregates.filter(agg => agg.accountId !== parentPortfolioId)

    if (aggregates.length === 0) return

    this.clearFilters()
    setFilter<Account>(
      'accountId',
      {
        type: 'in',
        filterType: 'number',
        filter: aggregates.map(agg => agg.accountId).join(','),
      },
      this.api,
    )
  }

  reloadTable() {
    this.api?.refreshServerSideStore({ purge: true })
  }
  shouldDisableAction(
    rows: RowNode[],
    action: AccountAvailableActions,
  ): boolean {
    if (rows === undefined) return true
    for (const row of rows) {
      const availableActions = row.data.availableActions
      if (
        availableActions == undefined ||
        availableActions.length == 0 ||
        !availableActions.includes(action)
      ) {
        return true
      }
    }
    return false
  }
  private registerHotkeys() {
    const ordinals = ['1st', '2nd', '3rd', '4th', '5th', '6th', '7th', '8th']
    for (let i = 0; i < ordinals.length; i++) {
      this.hotkeyDestroyStack.push(
        this.hotkeysService.bind(
          `highlight-row-with-${ordinals[i]}-color-in-account-list` as HighlightRowsInAccountList,
          () =>
            this.highlightService.setHighlightOnExternalAction(
              this.selectedRows,
              i,
            ),
        ),
      )
    }
  }
  private unregisterHotkeys() {
    this.hotkeyDestroyStack.forEach(hotkeyDestroyFn => hotkeyDestroyFn())
    this.hotkeyDestroyStack.length = 0
  }

  async setBellFilters(type: keyof Account, accountOwners: string[]) {
    this.clearFilters()
    this.advancedFiltersChanged({ hasOmegaDate: false })

    await setFilter<Account>(
      type,
      {
        filterType: 'set',
        values: accountOwners,
      },
      this.api,
    )
  }
}
